import React, { useState } from "react";
import { Head, router } from "@inertiajs/react";
import { Star, TrendingUp } from "lucide-react";
import { Review, Vehicle } from "../../types";
import ReviewsForm from "../../components/ReviewsForm";
import { ReviewFormStep } from "../../components/ReviewsForm/types";
import styles from "./styles.module.css";
import Badges from "../shared/components/Badges";
import homeBadges from "../../utils/homeBadges";
import Hero from "./components/Hero";
import { HowItWorks } from "../shared/components/HowItWorks";
import CarSection from "../Home/components/CarSection/CarSection";
import { TrustedComments } from "../shared/components/trustedComments/trustedComments";

type NewReviewProps = {
  review: Review;
  ask_user?: boolean;
  errors?: string[];
  part?: ReviewFormStep;
  top_rated_vehicles: Vehicle[];
  trending_vehicles: Vehicle[];
};

const trustedItems = [
  {
    rate: 9,
    vehicule: "RENAULT R5",
    posted_at: "14 octobre 2025",
    review: "Peut-être la meilleure voiture que j'ai eue",
  },
  {
    rate: 5,
    vehicule: "FORD PUMA",
    posted_at: "14 octobre 2025",
    review:
      "Le mode flexifuel consomme plus qu’on ne pourrait penser et l’entretient coûte cher",
  },
  {
    rate: 9,
    vehicule: "HYUNDAI BAYON",
    posted_at: "14 octobre 2025",
    review:
      "Véhicule agréable à conduire, conduite souple, très bien équipée, silencieuse et confortable",
  },
];

const NewReview: React.FC<NewReviewProps> = (props) => {
  const { top_rated_vehicles, trending_vehicles } = props;
  const [step, setStep] = useState<ReviewFormStep>(
    props.part || "license-plate",
  );

  const isAskUserStep = step === "ask-user";

  return (
    <div className={styles.container}>
      {isAskUserStep && (
        <Head>
          <title>Nouvelle évaluation de véhicule</title>
        </Head>
      )}
      <div className="flex flex-col gap-8">
        {!isAskUserStep && <Hero />}
        <ReviewsForm
          review={props.review}
          askUser={props.ask_user}
          errors={props.errors}
          initialStep={props.part}
          onStepChange={setStep}
          onSuccess={() => router.visit("/reviews")}
        />
      </div>
      {!isAskUserStep && (
        <>
          <Badges badges={homeBadges} />
          <div className="mt-4 w-full">
            <TrustedComments trustedItems={trustedItems} />
          </div>
          <HowItWorks showEvaluationPart={false} />
          <div className="car-section">
            <CarSection
              title="Les plus tendances"
              vehicles={trending_vehicles}
              icon={<TrendingUp className="icon-section" />}
            />
          </div>
          <div className="car-section">
            <CarSection
              title="Les mieux notés"
              vehicles={top_rated_vehicles}
              icon={<Star className="icon-section" />}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default NewReview;
